import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IPrepaidApplicationValidationDataTableRowFormMeta {
  
  appIDTable: FormInputMeta,
  appDateTable: FormInputMeta,  
  clientTable: FormInputMeta,
  classNumberTable: FormInputMeta,
  decidedByTable: FormInputMeta,
  deciDateTable: FormInputMeta,
  prepaidProgTable: FormInputMeta,
  cardProgTable: FormInputMeta,
  ADIRTable: FormInputMeta,

  schema: any,
}

const PrepaidApplicationValidationDataTableRowFormMeta = {} as IPrepaidApplicationValidationDataTableRowFormMeta;

 
PrepaidApplicationValidationDataTableRowFormMeta.appIDTable = {
  name: "appIDTable",
  label: "App. ID",
  type: "text",
  validation: yup.string().required(),
}
PrepaidApplicationValidationDataTableRowFormMeta.appDateTable = {
  name: "appDateTable",
  label: "App. Date",
  type: "date",
  validation: yup.string().required(),
}

PrepaidApplicationValidationDataTableRowFormMeta.clientTable = {
  name: "clientTable",
  label: "Client",
  type: "text",
  validation: yup.string().required(),
}
PrepaidApplicationValidationDataTableRowFormMeta.classNumberTable = {
  name: "classNumberTable",
  label: "N° Classe",
  type: "text",
  validation: yup.string().required(),
}
PrepaidApplicationValidationDataTableRowFormMeta.decidedByTable = {
  name: "decidedByTable",
  label: "Decidé par",
  type: "text",
  validation: yup.string().required(),
}
PrepaidApplicationValidationDataTableRowFormMeta.deciDateTable = {
  name: "deciDateTable",
  label: "Deci. Date",
  type: "date",
  validation: yup.string().required(),
}
PrepaidApplicationValidationDataTableRowFormMeta.prepaidProgTable = {
  name: "prepaidProgTable",
  label: "Prog. prépayé",
  type: "text",
  validation: yup.string().required(),
}
PrepaidApplicationValidationDataTableRowFormMeta.cardProgTable = {
  name: "cardProgTable",
  label: "Prog. carte",
  type: "text",
  validation: yup.string().required(),
}
PrepaidApplicationValidationDataTableRowFormMeta.ADIRTable = {
  name: 'ADIRTable',
  type: 'select',
  label: 'A.D.I.R.',
  options: [
    {
      label: 'A',
      value: 'a',
    },
    {
      label: 'D',
      value: 'd',
    },
    {
      label: 'I',
      value: 'i',
    },
    {
      label: 'R',
      value: 'r',
    },
  ],
  validation: yup.string().required(),
};


PrepaidApplicationValidationDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(PrepaidApplicationValidationDataTableRowFormMeta));

export default PrepaidApplicationValidationDataTableRowFormMeta;